import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getPediatricTraumaScoreSelector } from '../selectors'
import { PediatricTraumaScoreConstants } from '../store/pediatricTraumaScore.constants'
import { setTotalScore } from '../store/pediatricTraumaScore.actions'
import { IPediatricTraumaScoreState } from '../store/pediatricTraumaScore.types'

export function* calculatePediatricTraumaScore() {
  try {
    const pediatricTraumaScoreData: IPediatricTraumaScoreState = yield select(getPediatricTraumaScoreSelector)
    const { ptsSize, ptsCns, ptsAir, ptsBp, ptsSkel, ptsWound } = pediatricTraumaScoreData

    const validateTotal = (numberParamArr: any[]) => {
      let sum = 0
      let foundValidNumber = false

      numberParamArr.forEach((currentValue) => {
        if (typeof currentValue === 'number' && !isNaN(currentValue)) {
          sum += currentValue
          foundValidNumber = true
        }
      })

      return foundValidNumber ? sum : null
    }
    const numberParamArr = [ptsSize?.id, ptsCns?.id, ptsAir?.id, ptsBp?.id, ptsSkel?.id, ptsWound?.id]
    const totalSore = validateTotal(numberParamArr)
    yield put(setTotalScore(totalSore))
  } catch (e) {
    yield put(throwPcrException(`calculatePediatricTraumaScore() error: ${e}`))
  }
}
export function* calculatePediatricTraumaScoreSaga() {
  yield takeLatest(
    [
      PediatricTraumaScoreConstants.SET_SIZE,
      PediatricTraumaScoreConstants.SET_AIRWAY,
      PediatricTraumaScoreConstants.SET_SYSBP,
      PediatricTraumaScoreConstants.SET_CNS,
      PediatricTraumaScoreConstants.SET_SKELETAL_INJURY,
      PediatricTraumaScoreConstants.SET_OPEN_WOUNDS,
      PediatricTraumaScoreConstants.SET_PTS_DATA,
    ],
    calculatePediatricTraumaScore
  )
}
